import {Params} from '@feathersjs/feathers'

import {ProviderId, ProviderInfo, ProviderInfoId, ProviderInfoWithOptions} from '../../types'

import * as feathersService from '../feathers'

export type ProviderInfoRequest = Omit<ProviderInfo, 'id'>

export const RESOURCE = 'providerInfo'

const get = async <ProviderInfoType = ProviderInfo>(params?: Params) =>
  feathersService.find<ProviderInfoType>(RESOURCE, params)

export const getByProvider = async <ProviderInfoType = ProviderInfo>(provider: ProviderId) => {
  const params = {
    query: {
      provider,
    },
  }
  return get<ProviderInfoType>(params)
}

export const getById = async (id: ProviderInfoId) => feathersService.get<ProviderInfo>(RESOURCE, id)

export const getWithOptions = async (params?: Params) => {
  const parameters = {
    ...params,
    query: {
      ...params?.query,
      $modify: 'includeOptions',
    },
  }
  return get<ProviderInfoWithOptions>(parameters)
}

export const getWithOptionsByProvider = async (provider: ProviderId) => {
  const params = {
    query: {
      provider,
    },
  }
  return getWithOptions(params)
}

export const create = async (payload: ProviderInfoRequest) =>
  feathersService.create<ProviderInfo, ProviderInfoRequest>(RESOURCE, payload)

export const createMultiple = async (payload: ProviderInfoRequest[]) =>
  payload.length > 0
    ? feathersService.createMultiple<ProviderInfo, ProviderInfoRequest>(RESOURCE, payload)
    : Promise.resolve([])

export const update = async (payload: ProviderInfo, id: ProviderInfoId) =>
  feathersService.update<ProviderInfo>(RESOURCE, id, payload)

export const updateMultiple = async (payload: ProviderInfo, ids: ProviderInfoId[]) =>
  Promise.all(ids.map(id => update(payload, id)))

export const patch = async (payload: Partial<ProviderInfoRequest>, id: ProviderInfoId) =>
  feathersService.patch<ProviderInfo>(RESOURCE, id, payload)

export const patchMultiple = async (payload: Partial<ProviderInfoRequest>, ids: ProviderInfoId[]) =>
  Promise.all(ids.map(id => patch(payload, id)))

export const remove = async (id: ProviderInfoId) =>
  feathersService.remove<ProviderInfo>(RESOURCE, id)

export const removeMultiple = async (ids: ProviderInfoId[]) =>
  Promise.all(ids.map(id => remove(id)))
